module.exports = __webpack_public_path__ + "media/images/cash-white-057b813044488a7c43958714881a0529.png";